export const AddIcon = (props) => {
  const handler = () => {
    props.clickAction()
  }
  return (
    <div
      onClick={() => handler()}
      className="rounded-full border-2 border-primary flex items-center justify-center h-8 w-8 hover:bg-primary group cursor-pointer"
    >
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        className="pointer-events-none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="7.25"
          y1="15.5469"
          x2="7.25"
          y2="1.04762"
          className="stroke-primary group-hover:stroke-white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="0.25"
          y1="8.04688"
          x2="14.7493"
          y2="8.04688"
          className="stroke-primary group-hover:stroke-white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
